import { TourIdentifier } from '../models/state/tourDetails/TourIdentifier';

export const getOrgKeyByTourIdentifier = (tourIdentifier: TourIdentifier, contractorKey?: string) => {
  if (contractorKey) {
    return contractorKey;
  }

  return `oz:${tourIdentifier.orgId}`;
};
